/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Button, Typography, Spacer } from '@zapier/design-system';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
import Fields from './FormFields/Fields';
import { useFilterFields } from './hooks/useFilterFields';
const RebrandStyles = {
    additionalInfo: Object.assign(Object.assign({}, Typography.paragraph3), { color: Colors.neutral800, marginTop: '0px', marginBottom: '20px' }),
    buttonWrapper: {
        marginTop: '40px',
        display: 'flex',
        justifyContent: 'flex-end',
    },
};
/**
 * Renders a form with fields and a submit button.
 */
const EmailStep = ({ fields, formState, isCriticalTicketEligible, }) => {
    const filteredFields = useFilterFields({
        fields,
        isCriticalTicketEligible,
    });
    return (isolateComponent(Surface, { title: "Tell us about your issue" },
        isolateComponent("div", { css: RebrandStyles.additionalInfo }, "Please note the apps you are using and what you are hoping to accomplish. If you have an example that illustrates your question, please provide that as well."),
        isolateComponent(Spacer, { height: 10 }),
        isolateComponent(Fields, { fields: filteredFields }),
        isolateComponent(Spacer, { height: 10 }),
        isolateComponent("div", { css: RebrandStyles.buttonWrapper },
            isolateComponent(Button, { disabled: formState !== 'readyToSubmit', type: "submit" }, formState === 'submitting' ? 'Sending...' : 'Send'))));
};
export default EmailStep;
